import Box from '@mui/material/Box';

function ROW2View({ url }: Readonly<{ url: string }>): React.ReactElement {
    return (
        <Box sx={{ height: 'calc(100vh - 32px)' }}>
            <iframe title="ROW2 frame" src={window.location.origin + '/' + url} style={{ width: '100%', height: '100%' }} />
        </Box>
    );
}

export default ROW2View;
